import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {IconlyLightOutlineArrowDown21} from "../../../../../icons/IconlyLightOutlineArrowDown21";
import {Icons19} from "../../../../../icons/Icons19";
import useDynamicColors from "../../../../../hooks/useDynamicColors";
import "./style.css";

export const YoungCardDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const colors = useDynamicColors();

  const handleButtonBack = () => {
    const currentParams = location.search;
    navigate(`/vxlab-landing-young-mobile${currentParams}`);
  };

  return (
      <div className="young-card-details">
        <div className="overlap-wrapper-4">
          <div className="overlap-13">
            <div className="rectangle-19" />

            <div className="rectangle-20" />

            <div className="element-2">
              <div className="overlap-14">
                {/* <div className="group-14">
                <div className="ellipse-wrapper">
                  <div className="ellipse-11" />
                </div>
              </div> */}

                {/* <div className="frame-81">
                <div className="ellipse-12" />
              </div> */}

                <div className="frame-82">
                  <div className="group-15">
                    <div className="overlap-15">
                      <div className="debit-2">
                        <div className="overlap-16">
                          <div style={{ position: "block" }}>
                            <div>
                              {/* <div className="rectangle-21" /> */}
                              {/*
                            <img
                              className="rectangle-22"
                              alt="Rectangle"
                              src="/img/rectangle-1.png"
                            /> */}
                            </div>
                          </div>

                          <div
                              className="frame-83"
                              style={{
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "contain",
                                backgroundImage: colors.url_card
                                    ? `url(${colors.url_card})`
                                    : "none",
                                backgroundColor: colors.url_card
                                    ? "transparent"
                                    : "rgb(255,255,255, 0.3)",
                              }}
                          >
                            <div className="frame-90">
                              <div className="text-wrapper-70">
                                7531 4532 6643 5849
                              </div>

                              <img
                                  className="img-5"
                                  alt="Copy"
                                  src="/img/copy.svg"
                              />
                            </div>
                            <div className="frame-84">
                              <div className="text-wrapper-65">Available</div>

                              <div className="frame-85">
                                <div className="frame-86">
                                  <div className="frame-87">
                                    <div className="text-wrapper-66">13,000</div>

                                    <div className="text-wrapper-67">.23</div>
                                  </div>

                                  <div className="text-wrapper-68">USD</div>
                                </div>

                                <Icons19 className="img-5" color="white" />
                              </div>
                            </div>

                            <div className="frame-88">
                              <div className="text-wrapper-65">Assigned</div>

                              <div className="frame-89">
                                <div className="frame-87">
                                  <div className="text-wrapper-69">
                                    USD 23,000.00
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* <img
                          className="logo-visa-4"
                          alt="Logo visa"
                          src="/img/logo-visa-2.svg"
                        /> */}
                        </div>
                      </div>
                      {/*
                    <img
                      className="atomo-numb-token-2"
                      alt="Atomo numb token"
                      src="/img/atomo-numb-token-1.svg"
                    /> */}
                    </div>
                  </div>

                  <div className="frame-91">
                    <div className="frame-92">
                      <img
                          className="frame-93"
                          alt="Frame"
                          src="/img/frame-1171274973-1.svg"
                      />

                      <div className="text-wrapper-71">Pay</div>
                    </div>

                    <div className="frame-92">
                      <img
                          className="img-5"
                          alt="Pin code"
                          src="/img/pin-code.svg"
                      />

                      <div className="text-wrapper-71">PIN</div>
                    </div>

                    <div className="frame-92">
                      <img className="img-5" alt="File" src="/img/file.svg" />

                      <div className="text-wrapper-71">Statement</div>
                    </div>

                    <div className="frame-92">
                      <img
                          className="img-5"
                          alt="Calendar"
                          src="/img/calendar.svg"
                      />

                      <div className="text-wrapper-71">Installments</div>
                    </div>
                    {/*
                  <div className="frame-92">
                    <img
                      className="img-5"
                      alt="Speedometer"
                      src="/img/speedometer.svg"
                    />

                    <div className="text-wrapper-71">Limits</div>
                  </div> */}

                    <div className="frame-92">
                      <img
                          className="img-5"
                          alt="Warning"
                          src="/img/warning.png"
                      />

                      <div className="text-wrapper-71">Missing</div>
                    </div>
                  </div>
                </div>

                <div className="frame-94">
                  {/* <div className="bars-status-default-wrapper">
                  <div className="bars-status-default-2">
                    <div className="action-2">
                      <div className="text-wrapper-72">9:50</div>
                    </div>

                    <img
                      className="container-2"
                      alt="Container"
                      src="/img/container-1.png"
                    />
                  </div>
                </div> */}

                  <div className="panel-panel-primary-2">
                    <div className="title-6">Card details</div>
                    <div style={{ cursor: "pointer" }} onClick={handleButtonBack}>
                      <img
                          className="icons-arrow-back-2"
                          alt="Icons arrow back"
                          src="/img/icons-arrow-back-1.png"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="inside-wrapper">
              <div className="inside">
                <div className="frame-95">
                  <div className="subsection-3">
                    <div className="frame-96">
                      <div className="text-wrapper-73">Last activity</div>
                    </div>

                    <div className="iconly-light-outline-2">
                      <div className="text-wrapper-74">See all</div>

                      <IconlyLightOutlineArrowDown21
                          className="iconly-light-outline-arrow-down-2-1"
                          color="white"
                      />
                    </div>
                  </div>

                  <div className="frame-97">
                    <div className="frame-98">
                      <div className="overlap-group-21">
                        <img
                            className="vector-9"
                            alt="Vector"
                            src="/img/vector-270.svg"
                        />

                        <div className="ellipse-13" />

                        <div className="ellipse-14" />

                        <div className="ellipse-15" />

                        <div className="ellipse-16" />
                      </div>
                    </div>

                    <div className="frame-99">
                      <div className="feed-row-3">
                        <div className="data-2">
                          <img
                              className="frame-100"
                              alt="Frame"
                              src="/img/frame-480954771-1.svg"
                          />

                          <div className="frame-101">
                            <div className="frame-102">
                              <div className="name-2">Starbucks coffee time</div>

                              <img
                                  className="img-5"
                                  alt="Btn icon chevron"
                                  src="/img/btn-icon-chevron-5.svg"
                              />
                            </div>

                            <div className="subject-2">11/06/24</div>
                          </div>
                        </div>

                        <p className="amount-8">
                          <span className="text-wrapper-75">- $25</span>

                          <span className="text-wrapper-76">.11</span>
                        </p>
                      </div>

                      <div className="feed-row-3">
                        <div className="data-2">
                          <img
                              className="frame-100"
                              alt="Frame"
                              src="/img/frame-480954771-4.svg"
                          />

                          <div className="frame-103">
                            <div className="frame-102">
                              <div className="name-2">Bruno’s tricks</div>

                              <img
                                  className="img-5"
                                  alt="Btn icon chevron"
                                  src="/img/btn-icon-chevron-5.svg"
                              />
                            </div>

                            <div className="subject-2">11/06/24</div>
                          </div>
                        </div>

                        <p className="amount-8">
                          <span className="text-wrapper-75">- $12</span>

                          <span className="text-wrapper-76">.42</span>
                        </p>
                      </div>

                      <div className="feed-row-3">
                        <div className="data-2">
                          <img
                              className="frame-100"
                              alt="Frame"
                              src="/img/frame-480954771-2.svg"
                          />

                          <div className="frame-103">
                            <div className="frame-102">
                              <div className="name-2">New gymn shoes</div>

                              <img
                                  className="img-5"
                                  alt="Btn icon chevron"
                                  src="/img/btn-icon-chevron-5.svg"
                              />
                            </div>

                            <div className="subject-2">11/06/24</div>
                          </div>
                        </div>

                        <p className="amount-8">
                          <span className="text-wrapper-75">- $158</span>

                          <span className="text-wrapper-76">.68</span>
                        </p>
                      </div>

                      <div className="feed-row-3">
                        <div className="data-2">
                          <img
                              className="frame-100"
                              alt="Frame"
                              src="/img/frame-480954771-3.svg"
                          />

                          <div className="frame-103">
                            <div className="frame-102">
                              <div className="name-2">Card payment</div>

                              <img
                                  className="img-5"
                                  alt="Btn icon chevron"
                                  src="/img/btn-icon-chevron-5.svg"
                              />
                            </div>

                            <div className="subject-2">11/06/24</div>
                          </div>
                        </div>

                        <div className="frame-104">
                          <div className="amount-9">$950.23</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};
